import angular from 'angular';

const productSearchModule = angular.module('productSearchModule', ['ngTouch']).config(['$provide', function($provide) {
    // AEM-6499 - fix for IME Editor
    $provide.decorator('inputDirective', ['$delegate', '$log', function($delegate, $log) {
        // $log.debug('Hijacking input directive');
        const directive = $delegate[0];
        angular.extend(directive.link, {
            post: function(scope, element, attr, ctrls) {
                element.on('compositionupdate', function(event) {
                    $log.debug('Composition update, faking end');
                    element.triggerHandler('compositionend');
                });
            }
        });
        return $delegate;
    }]);
}]);

export default productSearchModule;
